
import { EntityState } from './state.js';
import { U_MODEL, U_MODEL2, U_MODEL3, U_MODEL4, U_FRAME8, U_FRAME16, U_SKIN8, U_SKIN16, U_EFFECTS8, U_EFFECTS16, U_RENDERFX8, U_RENDERFX16, U_ORIGIN1, U_ORIGIN2, U_ORIGIN3, U_ANGLE1, U_ANGLE2, U_ANGLE3, U_OLDORIGIN, U_SOUND, U_EVENT, U_SOLID, U_ALPHA, U_SCALE, U_INSTANCE_BITS, U_LOOP_VOLUME, U_LOOP_ATTENUATION_HIGH, U_OWNER_HIGH, U_OLD_FRAME_HIGH } from '@quake2ts/shared';

export function writeDeltaEntity(from: EntityState, to: EntityState, buffer: number[]): void {
    // Implementation pending / handled by MessageWriter
}

/**
 * Applies delta compression changes from a delta entity state to a baseline entity state.
 * @param target The baseline state to update (in-place)
 * @param delta The delta state containing changes and bitmask
 */
export function applyEntityDelta(target: EntityState, delta: EntityState): void {
    const bits = delta.bits;

    // Update metadata
    target.bits = bits;
    target.number = delta.number; // Ensure number is propagated

    if (bits & U_MODEL) target.modelindex = delta.modelindex;
    if (bits & U_MODEL2) target.modelindex2 = delta.modelindex2;
    if (bits & U_MODEL3) target.modelindex3 = delta.modelindex3;
    if (bits & U_MODEL4) target.modelindex4 = delta.modelindex4;

    if (bits & U_FRAME8) target.frame = delta.frame;
    if (bits & U_FRAME16) target.frame = delta.frame;

    if (bits & U_SKIN8) target.skinnum = delta.skinnum;
    if (bits & U_SKIN16) target.skinnum = delta.skinnum;

    if (bits & U_EFFECTS8) target.effects = delta.effects;
    if (bits & U_EFFECTS16) target.effects = delta.effects;

    if (bits & U_RENDERFX8) target.renderfx = delta.renderfx;
    if (bits & U_RENDERFX16) target.renderfx = delta.renderfx;

    if (bits & U_ORIGIN1) target.origin.x = delta.origin.x;
    if (bits & U_ORIGIN2) target.origin.y = delta.origin.y;
    if (bits & U_ORIGIN3) target.origin.z = delta.origin.z;

    if (bits & U_ANGLE1) target.angles.x = delta.angles.x;
    if (bits & U_ANGLE2) target.angles.y = delta.angles.y;
    if (bits & U_ANGLE3) target.angles.z = delta.angles.z;

    if (bits & U_OLDORIGIN) {
        target.old_origin.x = delta.old_origin.x;
        target.old_origin.y = delta.old_origin.y;
        target.old_origin.z = delta.old_origin.z;
    }

    if (bits & U_SOUND) target.sound = delta.sound;
    if (bits & U_EVENT) target.event = delta.event;
    if (bits & U_SOLID) target.solid = delta.solid;

    // Rerelease fields
    if (bits & U_ALPHA) target.alpha = delta.alpha;
    if (bits & U_SCALE) target.scale = delta.scale;
    if (bits & U_INSTANCE_BITS) target.instanceBits = delta.instanceBits;
    if (bits & U_LOOP_VOLUME) target.loopVolume = delta.loopVolume;
}
